import { atFaultIdentifierQueryFunction } from '@/common/queries/selections/atFaultIdentifier/atFaultIdentifierQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const atFaultIdentifierQueryOptions = () => {
  return queryOptions({
    queryKey: ['atFaultIdentifier'],
    queryFn: () => atFaultIdentifierQueryFunction(),
    select: (data) => {
      return data?.map((item) => ({
        label: item.name,
        value: item.id,
      }));
    },
  });
};
